/**
 * Normalize IB account external ids (`acct_{guid:N}` or bare guid) for equality.
 */
export const normalizeIbAccountId = (value) => {
  const raw = String(value || "").trim().toLowerCase();
  if (!raw) return "";
  return raw.startsWith("acct_") ? raw.slice(5) : raw;
};

const digitsOnly = (value) => String(value || "").replace(/\D/g, "");

/**
 * True when destination (lookup payload) is the same account as the active/source IB account.
 * Same CPF with a *different* account_id remains allowed (multi-account / ledger).
 */
export const isSameIbAccount = (destination, activeAccount) => {
  if (!destination || !activeAccount) return false;

  const destId = normalizeIbAccountId(
    destination.account_id || destination.accountId || destination.id,
  );
  const activeId = normalizeIbAccountId(
    activeAccount.id || activeAccount.account_id || activeAccount.accountId,
  );
  if (destId && activeId && destId === activeId) return true;

  const destNumber = digitsOnly(
    `${destination.account_code || destination.accountCode || ""}${
      destination.account_digit ?? destination.accountDigit ?? ""
    }`,
  );
  const activeNumber = digitsOnly(activeAccount.accountNumber || "");
  if (destNumber && activeNumber && destNumber === activeNumber) return true;

  return false;
};

export default isSameIbAccount;
